import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { PLANS_QUERY_KEYS } from "../queryKeys";
import { getPaymentTransactionDetails, getWalletTransactionDetails } from "../services/paymentTransactions";
import { Transaction } from "../types/transactions.types";
import { TransactionTypeEnum } from "../../enums/payment";

export const useGetTransactionDetails = (transaction: Transaction | undefined) => {
  const { i18n } = useTranslation();

  return useQuery({
    queryKey: [...PLANS_QUERY_KEYS.TRANSACTION_DETAILS, transaction?.id, transaction?.type, i18n.language],
    queryFn: async (): Promise<any> => {
      if (!transaction) {
        throw new Error("Transaction is required");
      }

      if (transaction.type === TransactionTypeEnum.Paid) {
        return getPaymentTransactionDetails(transaction.id);
      } else if (transaction.type === TransactionTypeEnum.Received) {
        return getWalletTransactionDetails(transaction.id);
      } else {
        throw new Error(`Unknown transaction type: ${transaction.type}`);
      }
    },
    enabled: !!transaction,
  });
};

